var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 16.2966H10.5C9.94999 16.2966 9.49999 15.8466 9.49999 15.2966V10.2966H7.90999C7.01999 10.2966 6.57999 9.21659 7.20999 8.58659L11.8 3.99659C11.9868 3.80933 12.2405 3.7041 12.505 3.7041C12.7695 3.7041 13.0232 3.80933 13.21 3.99659L17.8 8.58659C18.43 9.21659 17.98 10.2966 17.09 10.2966H15.5V15.2966C15.5 15.8466 15.05 16.2966 14.5 16.2966ZM18.5 18.2966H6.5C5.95 18.2966 5.5 18.7466 5.5 19.2966C5.5 19.8466 5.95 20.2966 6.5 20.2966H18.5C19.05 20.2966 19.5 19.8466 19.5 19.2966C19.5 18.7466 19.05 18.2966 18.5 18.2966Z",
    fill: "#66D1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.69ce4393b6bd88eb16912ccf4b91467a.svg";
export { ForwardRef as ReactComponent };